import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import TofuPage from './pages/TofuPage';
import SoymilkPage from './pages/SoymilkPage';
import BenefitsPage from './pages/BenefitsPage';
import TransparencyPage from './pages/TransparencyPage';
import MovementPage from './pages/MovementPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

const rootElement = document.getElementById('root');

// Check if we're in pre-rendered mode
if (rootElement.hasChildNodes()) {
  // Hydrate pre-rendered content
  const root = ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <div className="App">
          <Toaster position="top-right" richColors />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/tofu" element={<TofuPage />} />
              <Route path="/products/soymilk" element={<SoymilkPage />} />
              <Route path="/benefits" element={<BenefitsPage />} />
              <Route path="/transparency" element={<TransparencyPage />} />
              <Route path="/movement" element={<MovementPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  // Normal render for development
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <div className="App">
          <Toaster position="top-right" richColors />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/tofu" element={<TofuPage />} />
              <Route path="/products/soymilk" element={<SoymilkPage />} />
              <Route path="/benefits" element={<BenefitsPage />} />
              <Route path="/transparency" element={<TransparencyPage />} />
              <Route path="/movement" element={<MovementPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </React.StrictMode>
  );
}

